import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/guawa";

export default function Faqs() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr]">
        {/* 左侧文案 */}
        <div className="lg:sticky lg:top-24 lg:self-start">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">常见问题</span>
          <h2 className="mt-1 text-2xl font-extrabold tracking-tight text-ink-900 md:text-3xl">围观前先看这里</h2>
          <p className="mt-3 text-sm leading-relaxed text-ink-500">
            关于发言规则、投稿流程、内容来源与平台理念，这里帮你一次说清。没找到答案？欢迎随时来找我们。
          </p>
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-question-answer-line"></i> 联系瓜友客服
          </Link>
        </div>

        {/* FAQ 手风琴 */}
        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-200 bg-white" : "border-cream-200 bg-white"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="flex items-center gap-3 text-sm font-bold text-ink-900">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        open ? "bg-primary-500 text-white" : "bg-cream-200 text-ink-500"
                      }`}
                    >
                      {i + 1}
                    </span>
                    {f.q}
                  </h3>
                  <i
                    className={`text-lg text-primary-500 transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
                  ></i>
                </button>
                {open && (
                  <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-ink-500">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* FAQPage 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}